import useDomainCountryCode from "hooks/useDomainCountryCode";

const NoDealsOrPromos: React.FC<{
  type: "deals" | "promotions";
}> = ({ type }) => {
  const countryCode = useDomainCountryCode();

  return (
    <div className="my-xxl">
      This {countryCode === "CA" ? "store" : "dispensary"} isn’t sharing any
      {` ${type}`} right now. Check back later!
    </div>
  );
};

export default NoDealsOrPromos;
